/** @jsx isolateComponent */

import { Link, MessageBar } from '@zapier/common-components';

import {
  isolateComponent,
  labelStyles,
  responsiveStyles,
} from '@zapier/common-utils';

import { Colors } from '@zapier/theme';
import { useSendFullStoryEvent } from '@zapier/toolbox-tracking';

import { Size } from '@zapier/design-system-revenue/src/types';
import { usePricingPageSize } from '@zapier/design-system-revenue/src/utils';

type Props = {
  /** The function that's called when the View Details link is clicked. */
  toggleModal: (...args: any[]) => void;
};

const Styles = labelStyles(__filename, {
  root: {
    position: 'relative',
  },

  linkWrapper: (size: Size) => [
    {
      color: Colors.heroine,
      display: 'block',
      fontWeight: 700,
      marginTop: 5,
      position: 'relative',
    },
    responsiveStyles(size, {
      large: {
        marginTop: 0,
        position: 'absolute',
        right: 20,
        top: 15,
      },
      medium: {},
      small: {},
    }),
  ],
});

/**
 * An info bar that tells the user that they are on a plan that is no longer offered.
 */
export const LegacyPlanInfoBar = ({ toggleModal }: Props) => {
  const size = usePricingPageSize();
  useSendFullStoryEvent('Saw Legacy Plan Banner');

  return (
    <MessageBar
      borderRadius="large"
      hideIcon={true}
      title="Your current plan is no longer available."
      type="warning"
    >
      Stay on your current plan or switch to a new one below.
      <span css={Styles.linkWrapper(size)}>
        <Link onClick={toggleModal}>View Details</Link>
      </span>
    </MessageBar>
  );
};
